import { render, staticRenderFns } from "./Receivements.vue?vue&type=template&id=63722114"
import script from "./Receivements.vue?vue&type=script&lang=js"
export * from "./Receivements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports